import type { Entitlements, Transactions } from 'utils/types';
import ComboThumb from 'assets/img/combo_ielts_thumb.jpg';
import Ielts6Thumb from 'assets/img/ielts-6-thumb.jpg';
import Ielts7Thumb from 'assets/img/ielts-7-thumb.jpg';
import Ielts9Thumb from 'assets/img/ielts-9-thumb.jpg';
import env from './env';

const DEFAULT_DURATION = 'one_year';

export const getCurrentSubscription = (entitlements?: Entitlements | null) => {
  let membership = '';
  const code = entitlements?.tier?.code;
  const expireAt = entitlements?.tier?.expire_at;
  const transactions: Transactions[] = entitlements?.transactions || [];

  const getDuration = (catalog: string) => {
    const latestTrans : Transactions[] = transactions.filter(item => item.catalog === catalog && item.status === 'granted').sort((a, b) => b.created_at - a.created_at);
    return latestTrans[0]?.duration;
  }

  if (code === 'pro') {
    if (expireAt === null) {
      membership = 'lifetime_membership'
      const isConversationBundle = transactions.filter(item => item.catalog === 'ai_role_play_sa' && item.status === 'granted');
      if (isConversationBundle.length) {
        membership = 'lifetime_membership_ai_role_play_sa';
      }
    } else {
      const duration = getDuration('elsa_speak') || DEFAULT_DURATION;
      membership = `${duration}_credit`;
    }
  } else if (code === 'premium') {
    const duration = getDuration('elsa_speak') || getDuration('premium') || DEFAULT_DURATION;
    membership = `${duration}_credit_premium`;
  } else if (code === 'free') {
    membership = 'free';
  }

  return membership;
}

export const bookMapping = (book: string) => {
  const bookList: { [key: string]: string } = {
    lifetime_membership_harcoltoeic: 'book_1_lifetime_toeic_hpc',
    lifetime_membership_harcoltoefl: 'book_2_lifetime_toefl_hpc',
    lifetime_membership_harcolielts1: 'book_3_lifetime_ready_ielts_hpc',
    lifetime_membership_harcolielts2: 'book_4_lifetime_speaking_ielts_hpc',
    lifetime_membership_harpercollins_full_course: 'hpc_all_books',
    lifetime_membership_ielts6: 'ielts_band_6',
    lifetime_membership_ielts7: 'ielts_band_7',
    lifetime_membership_ielts9: 'ielts_band_9',
    lifetime_membership_ielts_band_679: 'combo_ielts_band_6_7_9',
    lifetime_membership_oxford_all_books: 'oxford_all_books',
    lifetime_membership_oxford_starter: 'oxford_starter',
    lifetime_membership_oxford_elementary: 'oxford_elementary',
    lifetime_membership_oxford_pre_intermediate: 'oxford_pre_intermediate',
    lifetime_membership_oxford_intermediate: 'oxford_intermediate',
    lifetime_membership_oxford_upper_intermediate: 'oxford_upper_intermediate',
    lifetime_membership_oxford_advanced: 'oxford_advanced',
  };

  if(bookList.hasOwnProperty(book)) 
    return bookList[book];
  
  return "";
};

export const bookImage = (book: string) => {
  const config = env();

  const bookImage:{ [key: string]: string } = {
    oxford_all_books: config.internalApiUrl + '/wp-content/themes/theme-user/assets/images/book-oxford/oxford_all_books.jpeg',
    oxford_starter: config.internalApiUrl + '/wp-content/themes/theme-user/assets/images/book-oxford/oxford_starter.jpeg',
    oxford_elementary: config.internalApiUrl + '/wp-content/themes/theme-user/assets/images/book-oxford/oxford_elementary.jpeg',
    oxford_pre_intermediate: config.internalApiUrl + '/wp-content/themes/theme-user/assets/images/book-oxford/oxford_pre_intermediate.jpeg',
    oxford_intermediate: config.internalApiUrl + '/wp-content/themes/theme-user/assets/images/book-oxford/oxford_intermediate.jpeg',
    oxford_upper_intermediate: config.internalApiUrl + '/wp-content/themes/theme-user/assets/images/book-oxford/oxford_upper_intermediate.jpeg',
    oxford_advanced: config.internalApiUrl + '/wp-content/themes/theme-user/assets/images/book-oxford/oxford_advanced.jpeg',
    hpc_all_books: config.internalApiUrl + '/wp-content/themes/theme-user/assets/images/harper-collins/hpc_all_books.jpg',
    book_4_lifetime_speaking_ielts_hpc: config.internalApiUrl + '/wp-content/themes/theme-user/assets/images/harper-collins/hpc_book_4.jpg',
    book_3_lifetime_ready_ielts_hpc: config.internalApiUrl + '/wp-content/themes/theme-user/assets/images/harper-collins/hpc_book_3.jpg',
    book_2_lifetime_toefl_hpc: config.internalApiUrl + '/wp-content/themes/theme-user/assets/images/harper-collins/hpc_book_2.jpg',
    book_1_lifetime_toeic_hpc: config.internalApiUrl + '/wp-content/themes/theme-user/assets/images/harper-collins/hpc_book_1.jpg',
    combo_ielts_band_6_7_9: ComboThumb,
    ielts_band_6: Ielts6Thumb,
    ielts_band_7: Ielts7Thumb,
    ielts_band_9: Ielts9Thumb,
  };

  if(bookImage.hasOwnProperty(book)) 
    return bookImage[book];
  
  return "";
}